import ActionTypes from '../actions/actionTypes';

const initialState = {
  isLoading: false,
  accounts: [],
  isError: false,
  totalSize: 0,
  hierarchy: false,

  isAllAccountsLoading: false,
  isAllAccountsLoaded: false,
  isAllAccountsError: false,
  allAccounts: [],
  allAccountsTotalSize: 0,

  searchTerm: '',
  addressDetails: [],
  addressName: undefined,
  address: undefined,
  businessPhone: undefined,
  locationAdress: undefined,
  isAddressLoading: false,
  isAddressLoaded: false,
  isAddressError: false,
  isAddressUpdateLoaded: false,
  isAddressUpdateLoading: false,
  isAddressUpdateError: false,
  isInvoicesLoading: false,
  isInvoicesError: false,
  isFileDownLoading: false,
  isFileDownLoadingError: false,
  invoicesFilter: {
    type: 'All',
    from: undefined,
    to: undefined,
  },
  invoices: [],
  totalInvoiceStatementRecords: undefined,
  paymentTypeLoading: false,
  paymentTypeLoaded: false,
  paymentTypeError: false,
  paymentType: undefined,
  makePaymentLoading: false,
  makePaymentLoaded: false,
  makePaymentError: false,
  grandparentAccountLoading: false,
  grandparentAccountLoaded: false,
  grandparentAccountError: false,
  grandparentAccount: undefined,

  contractBalancesLoading: false,
  contractBalancesLoaded: false,
  contractBalancesError: false,
  contractBalances: [],

  acquiringContractAddressLoading: false,
  acquiringContractAddressLoaded: false,
  acquiringContractAddressError: false,
  acquiringContractAddress: null,

  getAccountsForUserLoading: false,
  getAccountsForUserLoaded: false,
  getAccountsForUserError: false,
  getAccountsForUserResult: null,

  transferCardTargetAccountsLoading: false,
  transferCardTargetAccountsLoaded: false,
  transferCardTargetAccountsError: false,
  transferCardTargetAccounts: [],
};

export function accountsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.ACCOUNTS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        accounts: [],
        hierarchy: false,
      };
    case ActionTypes.ACCOUNTS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        accounts: payload.accounts,
        totalSize: payload.totalSize,
        hierarchy: payload.hierarchy,
      };
    case ActionTypes.ACCOUNTS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        accounts: [],
        totalSize: 0,
        hierarchy: false,
      };
    case ActionTypes.ACCOUNTS.ALL.REQUEST:
      return {
        ...state,
        isAllAccountsLoading: true,
        isAllAccountsLoaded: false,
        isAllAccountsError: false,
        allAccounts: [],
        allAccountsTotalSize: 0,
      };
    case ActionTypes.ACCOUNTS.ALL.SUCCESS:
      return {
        ...state,
        isAllAccountsLoading: false,
        isAllAccountsLoaded: true,
        isAllAccountsError: false,
        allAccounts: payload.accounts,
        allAccountsTotalSize: payload.totalSize,
      };
    case ActionTypes.ACCOUNTS.ALL.FAILURE:
      return {
        ...state,
        isAllAccountsLoading: false,
        isAllAccountsLoaded: false,
        isAllAccountsError: true,
        allAccounts: [],
        allAccountsTotalSize: 0,
      };
    case ActionTypes.ACCOUNTS.RESET:
      return {
        ...state,
        accounts: [],
        totalSize: 0,
        hierarchy: false,
      };
    case ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.REQUEST:
      return {
        ...state,
        transferCardTargetAccountsLoading: true,
        transferCardTargetAccountsLoaded: false,
        transferCardTargetAccountsError: false,
        transferCardTargetAccounts: []
      };
    case ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.SUCCESS:
      return {
        ...state,
        transferCardTargetAccountsLoading: false,
        transferCardTargetAccountsLoaded: true,
        transferCardTargetAccounts: payload.accounts
      };
    case ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.FAILURE:
      return {
        ...state,
        transferCardTargetAccountsLoading: false,
        transferCardTargetAccountsError: true,
      };
    case ActionTypes.ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.RESET:
      return {
        ...state,
        transferCardTargetAccountsLoading: false,
        transferCardTargetAccountsLoaded: false,
        transferCardTargetAccountsError: false,
        transferCardTargetAccounts: []
      };
    case ActionTypes.ACCOUNTS.UPDATE.SEARCH_TERM:
      return {
        ...state,
        searchTerm: payload.searchTerm,
      };
    case ActionTypes.ADDRESSES.REQUEST:
      return {
        ...state,
        isAddressLoading: true,
        isAddressLoaded: false,
        isAddressError: false,
      };
    case ActionTypes.ADDRESSES.SUCCESS:
      return {
        ...state,
        isAddressLoading: false,
        isAddressLoaded: true,
        addressDetails: payload.addressesDetails,
        addressName: payload.addressesDetails?.[0].addressName,
        businessPhone: payload.addressesDetails?.[0].businessPhone,
        address: payload.addressesDetails?.[0].location,
      };
    case ActionTypes.ADDRESSES.FAILURE:
      return {
        ...state,
        isAddressLoading: false,
        isAddressError: true,
      };
    case ActionTypes.ADDRESSES.UPDATE.REQUEST:
      return {
        ...state,
        isAddressUpdateLoading: true,
        isAddressUpdateLoaded: false,
        isAddressUpdateError: false,
      };
    case ActionTypes.ADDRESSES.UPDATE.SUCCESS:
      return {
        ...state,
        isAddressUpdateLoading: false,
        isAddressUpdateLoaded: true,
      };
    case ActionTypes.ADDRESSES.UPDATE.FAILURE:
      return {
        ...state,
        isAddressUpdateLoading: false,
        isAddressUpdateError: true,
      };
    case ActionTypes.ADDRESSES.UPDATE.RESET:
      return {
        ...state,
        addressDetails: [],
        isAddressLoaded: false,
        isAddressUpdateLoading: false,
        isAddressUpdateLoaded: false,
        isAddressUpdateError: false,
      };
    case ActionTypes.ACCOUNTS.INVOICES.REQUEST:
      return {
        ...state,
        isInvoicesLoading: true,
        isInvoicesError: false,
      };
    case ActionTypes.ACCOUNTS.INVOICES.SUCCESS:
      return {
        ...state,
        isInvoicesLoading: false,
        invoices: payload.result,
        totalInvoiceStatementRecords: payload.resultSize,
      };
    case ActionTypes.ACCOUNTS.INVOICES.FAILURE:
      return {
        ...state,
        isInvoicesLoading: false,
        isInvoicesError: true,
      };
    case ActionTypes.ACCOUNTS.INVOICES.RESET:
      return {
        ...state,
        isInvoicesLoading: false,
        isInvoicesError: false,
        invoices: [],
      };
    case ActionTypes.ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.SUCCESS:
      return {
        ...state,
        isFileDownLoading: false,
        isFileDownLoadingError: false,
      };
    case ActionTypes.ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.REQUEST:
      return {
        ...state,
        isFileDownLoading: true,
        isFileDownLoadingError: false,
      };
    case ActionTypes.ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.FAILURE:
      return {
        ...state,
        isFileDownLoading: false,
        isFileDownLoadingError: true,
      };
    case ActionTypes.ACCOUNTS.PAYMENT_TYPE.REQUEST:
      return {
        ...state,
        paymentTypeLoading: true,
        paymentTypeLoaded: false,
      };
    case ActionTypes.ACCOUNTS.PAYMENT_TYPE.SUCCESS:
      return {
        ...state,
        paymentTypeLoading: false,
        paymentTypeLoaded: true,
        paymentType: payload.response,
      };
    case ActionTypes.ACCOUNTS.PAYMENT_TYPE.FAILURE:
      return {
        ...state,
        paymentTypeLoading: false,
        paymentTypeError: true,
      };
    case ActionTypes.ACCOUNTS.PAYMENT_TYPE.RESET:
      return {
        ...state,
        paymentType: undefined,
        paymentTypeLoading: false,
        paymentTypeLoaded: false,
        paymentTypeError: false,
      };
    case ActionTypes.ACCOUNTS.PAYMENT.REQUEST:
      return {
        ...state,
        makePaymentLoading: true,
        makePaymentLoaded: false,
      };
    case ActionTypes.ACCOUNTS.PAYMENT.SUCCESS:
      return {
        ...state,
        makePaymentLoading: false,
        makePaymentLoaded: true,
        accounts: state.accounts.map(account => account.contractNumber === payload?.response?.accountNumber ? { ...account, balance: payload?.response?.balance } : account),
      };
    case ActionTypes.ACCOUNTS.PAYMENT.FAILURE:
      return {
        ...state,
        makePaymentLoading: false,
        makePaymentError: true,
      };
    case ActionTypes.ACCOUNTS.PAYMENT.RESET:
      return {
        ...state,
        makePaymentLoading: false,
        makePaymentLoaded: false,
        makePaymentError: false,
      };
    case ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.REQUEST:
      return {
        ...state,
        grandparentAccountLoading: true,
        grandparentAccountLoaded: false,
        grandparentAccountError: false,
        grandparentAccount: undefined,
      };
    case ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.SUCCESS:
      return {
        ...state,
        grandparentAccountLoading: false,
        grandparentAccountLoaded: true,
        grandparentAccount: payload.response
      };
    case ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.FAILURE:
      return {
        ...state,
        grandparentAccount: false,
        grandparentAccountError: true,
        grandparentAccountLoading: false,
      };
    case ActionTypes.ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.RESET:
      return {
        ...state,
        grandparentAccountLoading: false,
        grandparentAccountLoaded: false,
        grandparentAccountError: false,
        grandparentAccount: undefined,
      };
    case ActionTypes.ACCOUNTS.CONTRACT_BALANCES.REQUEST:
      return {
        ...state,
        contractBalancesLoading: true,
        contractBalancesLoaded: false,
        contractBalancesError: false,
        contractBalances: []
      };
    case ActionTypes.ACCOUNTS.CONTRACT_BALANCES.SUCCESS:
      return {
        ...state,
        contractBalancesLoading: false,
        contractBalancesLoaded: true,
        contractBalances: payload.response,
      };
    case ActionTypes.ACCOUNTS.CONTRACT_BALANCES.FAILURE:
      return {
        ...state,
        contractBalancesLoading: false,
        contractBalancesError: true,
      };
    case ActionTypes.ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.REQUEST:
      return {
        ...state,
        acquiringContractAddressLoading: true,
        acquiringContractAddressLoaded: false,
        acquiringContractAddressError: false,
        acquiringContractAddress: null,
      };
    case ActionTypes.ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.SUCCESS:
      return {
        ...state,
        acquiringContractAddressLoading: false,
        acquiringContractAddressLoaded: true,
        acquiringContractAddress: payload.response,
      };
    case ActionTypes.ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.FAILURE:
      return {
        ...state,
        acquiringContractAddressLoading: false,
        acquiringContractAddressError: true,
      };
    case ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.REQUEST:
      return {
        ...state,
        getAccountsForUserLoading: true,
        getAccountsForUserLoaded: false,
        getAccountsForUserError: false,
        getAccountsForUserResult: null,
      };
    case ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.SUCCESS:
      return {
        ...state,
        getAccountsForUserLoading: false,
        getAccountsForUserLoaded: true,
        getAccountsForUserResult: payload.getAccountsForUserResult,
      };
    case ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.FAILURE:
      return {
        ...state,
        getAccountsForUserLoading: false,
        getAccountsForUserError: true,
      };
    case ActionTypes.ACCOUNTS.GET_ACCOUNTS_FOR_USER.RESET:
      return {
        ...state,
        getAccountsForUserLoading: false,
        getAccountsForUserLoaded: false,
        getAccountsForUserError: false,
        getAccountsForUserResult: null,
      };
    default:
      return state;
  }
}
